// extracted by mini-css-extract-plugin
module.exports = {"checkboxOption":"CheckboxView_checkboxOption__KZFL6","checked":"CheckboxView_checked__l2JFl","label":"CheckboxView_label__7gtXY"};